import type { Product } from "@/contexts/product-context"
import { isProductEntitled } from "@/lib/mock/product-catalog"
import { ONE_SITE_SURVEYS_EMBED_URL } from "@/lib/one-site-demo"

const SURVEYS_PRODUCT: Product = "exxat-surveys"

/** Deployed Surveys app; Open leaves Exxat Home for the hosted URL. */
export function getSurveysHostedHref(): string | null {
  if (!isProductEntitled(SURVEYS_PRODUCT)) return null
  return ONE_SITE_SURVEYS_EMBED_URL
}

export function openSurveysHostedAppIfEntitled(): boolean {
  const href = getSurveysHostedHref()
  if (!href) return false
  window.location.assign(href)
  return true
}

export function isExternalProductHref(href: string | undefined): href is string {
  return href != null && (href.startsWith("https://") || href.startsWith("http://"))
}
